import { useState, useMemo } from 'react'
import { Organization } from 'interfaces/organization'
import {
  isOrganizationUpdated,
  isOrganizationPending,
} from 'utils/organization-utils'

export const useOrganizationFilters = (organizations: Organization[]) => {
  const [searchTerm, setSearchTerm] = useState('')
  const [accountManagerFilter, setAccountManagerFilter] = useState('')
  const [salesRepFilter, setSalesRepFilter] = useState('')
  const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('desc')
  const [showUpdatedOnly, setShowUpdatedOnly] = useState(false)

  const filteredAndSortedOrganizations = useMemo(() => {
    let filtered = organizations

    if (searchTerm) {
      filtered = filtered.filter((org) => {
        const searchLower = searchTerm.toLowerCase()
        const orgName = org.name?.toLowerCase() || ''
        const orgId = org.id?.toString() || ''
        return orgName.includes(searchLower) || orgId.includes(searchTerm)
      })
    }

    if (accountManagerFilter) {
      if (accountManagerFilter === 'missing') {
        filtered = filtered.filter((org) => !org.account_manager_user_id)
      } else {
        filtered = filtered.filter(
          (org) =>
            org.account_manager_user_id?.toString() === accountManagerFilter
        )
      }
    }

    if (salesRepFilter) {
      if (salesRepFilter === 'missing') {
        filtered = filtered.filter(
          (org) => !org.organization_subscription?.sale_rep_id
        )
      } else {
        filtered = filtered.filter(
          (org) =>
            org.organization_subscription?.sale_rep_id?.toString() ===
            salesRepFilter
        )
      }
    }

    if (showUpdatedOnly) {
      filtered = filtered.filter(isOrganizationUpdated)
    } else {
      filtered = filtered.filter(isOrganizationPending)
    }

    return filtered.sort((a, b) => {
      const dateA = new Date(a.created_at || 0).getTime()
      const dateB = new Date(b.created_at || 0).getTime()
      return sortOrder === 'desc' ? dateB - dateA : dateA - dateB
    })
  }, [
    organizations,
    searchTerm,
    accountManagerFilter,
    salesRepFilter,
    sortOrder,
    showUpdatedOnly,
  ])

  return {
    searchTerm,
    setSearchTerm,
    accountManagerFilter,
    setAccountManagerFilter,
    salesRepFilter,
    setSalesRepFilter,
    sortOrder,
    setSortOrder,
    showUpdatedOnly,
    setShowUpdatedOnly,
    filteredAndSortedOrganizations,
  }
}
